import './reset.css';
import './type.css';
import './var.css';
import './App.css';
import unwrap from "./assets/unwrap.svg";
import wrap from "./assets/wrap.svg";
import logo from "./assets/logo.svg";
import curio from "./assets/CURIO.svg";
import cards from "./assets/CARDS.svg";
import cardOg from "./assets/17.png";
import cardBootleg from "./assets/17b-bootleg.png";
import cardNew from "./assets/17b-cryptopop.png";

import * as constants from "./constants.js";
//import * as constants from "./goerli-constants.js";

import React, { useState, useEffect } from 'react';
import { ethers } from "ethers";

const { ethereum } = window;
if (ethereum) {
  var provider = new ethers.providers.Web3Provider(ethereum);
  var signer = provider.getSigner();
}

function App() {
  const [status, setStatus] = useState({ "color": "red", "blink": false, "message": "Metamask not detected" });
  const [connected, setConnected] = useState(false);
  const [metamaskPresent, setMetamaskPresent] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const [erc20Balance, setErc20Balance] = useState(0);
  const [newWrapperBalance, setNewWrapperBalance] = useState(0);
  const [oldWrapperBalance, setOldWrapperBalance] = useState(0);

  const [numToWrapFromErc20, setNumToWrapFromErc20] = useState(0);
  const [numToUnwrapFromNewWrapper, setNumToUnwrapFromNewWrapper] = useState(0);
  const [numToUnwrapFromOldWrapper, setNumToUnwrapFromOldWrapper] = useState(0);

  useEffect(() => {
    console.debug("useEffect");

    if (!provider) {
      console.error("Your browser is not web3 enabled.");
      setStatus({ "color": "red", "blink": false, "message": "Please install metamask" });
      return;
    }

    provider.listAccounts().then(accts => {
      if (accts && accts.length > 0) {
        // already connected
        console.debug("already connected; accts: " + accts);
        setMetamaskPresent(true);
        setConnected(true);
        setStatus({ "color": "green", "blink": false, "message": "Connected to " + accts[0] });
        populateBalances();
      } else {
        // prompt user to connect
        setMetamaskPresent(true);
        setStatus({ "color": "orange", "blink": false, "message": "Connect your wallet to continue" });
      }
    });
  }, []);

  async function connectWallet() {
    console.debug("connectWallet");
    await ethereum.request({
      method: 'eth_requestAccounts'
    });

    const accts = await provider.listAccounts();
    setConnected(true);
    setStatus({ "color": "green", "blink": false, "message": "Connected to " + accts[0] });
    populateBalances();
  }

  async function populateBalances() {
    console.debug("populateBalances");
    const accts = await provider.listAccounts();
    const userAddr = accts[0];

    // populate erc20 balance
    const erc20Contract = await new ethers.Contract(constants.erc20Address, constants.erc20Abi, provider);
    erc20Contract.balanceOf(userAddr).then(balance => {
      console.debug("erc20 balance: " + balance);
      setErc20Balance(Number(balance));
    });

    // populate newWrapper balance
    const newWrapperContract = await new ethers.Contract(constants.newWrapperAddr, constants.newWrapperAbi, provider);
    newWrapperContract.balanceOfBatch([userAddr], [172]).then(balances => {
      console.debug("newWrapper balance: " + balances);
      setNewWrapperBalance(Number(balances[0]));
    });

    // populate oldWrapper balance
    const oldWrapperContract = await new ethers.Contract(constants.oldWrapperAddr, constants.oldWrapperAbi, provider);
    oldWrapperContract.balanceOfBatch([userAddr], [172]).then(balances => {
      console.debug("oldWrapper balance: " + balances);
      setOldWrapperBalance(Number(balances[0]));
    });
  }

  async function resetInputs() {
    setNumToWrapFromErc20(0);
    setNumToUnwrapFromNewWrapper(0);
    setNumToUnwrapFromOldWrapper(0);
  }

  async function wrapOriginalTokens() {
    console.debug("wrapOriginalTokens");

    try {
      setInProgress(true);
      const accts = await provider.listAccounts();
      const userAddr = accts[0];
      const erc20Contract = new ethers.Contract(constants.erc20Address, constants.erc20Abi, signer);
      const newWrapperContract = new ethers.Contract(constants.newWrapperAddr, constants.newWrapperAbi, signer);

      const allowanceToSpend = await erc20Contract.allowance(userAddr, constants.newWrapperAddr);
      console.debug("current allowance: " + allowanceToSpend);

      if (allowanceToSpend == 0) {
        setStatus({ "color": "orange", "blink": true, "message": "Executing transaction 1 of 2: approving ERC20 curio for new wrapper…" });

        // seek approval
        const approvalResult = await erc20Contract.approve(constants.newWrapperAddr, 2000);
        console.debug("approvalResult:");
        console.debug(approvalResult);
        const receipt = await approvalResult.wait();
        console.debug("receipt:");
        console.debug(receipt);

        setStatus({ "color": "orange", "blink": true, "message": "Executing transaction 2 of 2: wrapping to new wrapper…" });
      } else {
        setStatus({ "color": "orange", "blink": true, "message": "Executing transaction 1 of 1: wrapping to new wrapper…" });
      }

      // wrap to new wrapper
      const wrapResult = await newWrapperContract.wrap(172, numToWrapFromErc20);
      console.debug("wrapResult:");
      const receipt = await wrapResult.wait();
      console.debug("receipt:");
      console.debug(receipt);
      setStatus({ "color": "green", "blink": false, "message": "Wrap completed" });
    } catch (e) {
      setStatus({ "color": "red", "blink": false, "message": "Wrap failed" });
      if (e.code) {
        console.warn("Received Metamask errorcode: " + e.code);
        if (e.code == "ACTION_REJECTED") {
          setStatus({ "color": "red", "blink": false, "message": "Metamask error: User denied transaction signature" });
        } else {
          setStatus({ "color": "red", "blink": false, "message": "Metamask error " + e.code });
        }
      } else {
        setStatus({ "color": "red", "blink": false, "message": "Unexpected error while executing transaction. Contact the Curio Discord for help." });
      }
      // rethrow for logging
      throw e;
    } finally {
      setInProgress(false);
      resetInputs();
      populateBalances();
    }
  }

  async function unwrapNewWrapperTokens() {
    console.debug("unwrapNewWrapperTokens");

    try {
      setInProgress(true);
      const newWrapperContract = new ethers.Contract(constants.newWrapperAddr, constants.newWrapperAbi, signer);

      setStatus({ "color": "orange", "blink": true, "message": "Executing transaction 1 of 1: unwrapping tokens…" });
      const unwrapResult = await newWrapperContract.unwrap(172, numToUnwrapFromNewWrapper);
      console.debug("unwrapResult:");
      const receipt = await unwrapResult.wait();
      console.debug("receipt:");
      console.debug(receipt);

      setStatus({ "color": "green", "blink": false, "message": "Unwrap completed" });
    } catch (e) {
      setStatus({ "color": "red", "blink": false, "message": "Wrap failed" });
      if (e.code) {
        console.warn("Received Metamask errorcode: " + e.code);
        if (e.code == "ACTION_REJECTED") {
          setStatus({ "color": "red", "blink": false, "message": "Metamask error: User denied transaction signature" });
        } else {
          setStatus({ "color": "red", "blink": false, "message": "Metamask error " + e.code });
        }
      } else {
        setStatus({ "color": "red", "blink": false, "message": "Unexpected error while executing transaction. Contact the Curio Discord for help." });
      }
      // rethrow for logging
      throw e;
    } finally {
      setInProgress(false);
      resetInputs();
      populateBalances();
    }
  }

  async function unwrapOldWrapperTokens() {
    console.debug("unwrapOldWrapperTokens");

    try {
      setInProgress(true);
      const accts = await provider.listAccounts();
      const userAddr = accts[0];
      const oldWrapperContract = new ethers.Contract(constants.oldWrapperAddr, constants.oldWrapperAbi, signer);
      const newWrapperContract = new ethers.Contract(constants.newWrapperAddr, constants.newWrapperAbi, signer);

      // check if user has approval for erc20
      const erc20Contract = new ethers.Contract(constants.erc20Address, constants.erc20Abi, signer);
      const allowanceToSpend = await erc20Contract.allowance(userAddr, constants.newWrapperAddr);
      console.debug("current allowance: " + allowanceToSpend);

      let totalTxCount = 2;
      let currentTxCount = 1;
      if (allowanceToSpend == 0) {
        totalTxCount = 3;
      }

      //await erc20Contract.approve(constants.newWrapperAddr, 0);
      //throw "debug";

      const _wrapNum = numToUnwrapFromOldWrapper;

      // Step 1: unwrap from old wrapper
      setStatus({ "color": "orange", "blink": true, "message": `Executing transaction ${currentTxCount} of ${totalTxCount}: unwrapping from old wrapper…` });
      currentTxCount++;
      const unwrapResult = await oldWrapperContract.unwrap(172, _wrapNum);
      console.debug("unwrapResult:");
      const receipt = await unwrapResult.wait();
      console.debug("receipt:");
      console.debug(receipt);
      populateBalances();

      // Step 2: approve erc20 to new wrapper, if needed
      if (allowanceToSpend == 0) {
        setStatus({ "color": "orange", "blink": true, "message": `Executing transaction ${currentTxCount} of ${totalTxCount}: approving ERC20 curio for new wrapper…` });
        currentTxCount++;

        const approvalResult = await erc20Contract.approve(constants.newWrapperAddr, 2000);
        console.debug("approvalResult:");
        console.debug(approvalResult);
        const receipt = await approvalResult.wait();
        console.debug("receipt:");
        console.debug(receipt);
      }

      // Step 3: wrap to new wrapper
      setStatus({ "color": "orange", "blink": true, "message": `Executing transaction ${currentTxCount} of ${totalTxCount}: wrapping to new wrapper…` });

      const wrapResult = await newWrapperContract.wrap(172, _wrapNum);
      console.debug("wrapResult:");
      const receipt2 = await wrapResult.wait();
      console.debug("receipt2:");
      console.debug(receipt2);

      setStatus({ "color": "green", "blink": false, "message": "Wrap completed" });
    } catch (e) {
      setStatus({ "color": "red", "blink": false, "message": "Wrap failed" });
      if (e.code) {
        console.warn("Received Metamask errorcode: " + e.code);
        if (e.code == "ACTION_REJECTED") {
          setStatus({ "color": "red", "blink": false, "message": "Metamask error: User denied transaction signature" });
        } else {
          setStatus({ "color": "red", "blink": false, "message": "Metamask error " + e.code });
        }
      } else {
        setStatus({ "color": "red", "blink": false, "message": "Unexpected error while executing transaction. Contact the Curio Discord for help." });
      }
      // rethrow for logging
      throw e;
    } finally {
      setInProgress(false);
      resetInputs();
      populateBalances();
    }
  }

  return (
    <>
      <header className="center border cell white">
        <div id="connection-indicator" className={`circle circle-${status.color} ${status.blink ? 'circle-blink' : ''}`}></div> <p>{status.message}</p>
      </header>
      <nav>
        <img src={logo} className="center logo border white" alt="" />
        <div className="title center border pinkLight"><p>Card #17B Wrapper</p></div>
      </nav>

      <div className="wrapper-of-wrappers">
        <section className={`original-token ${connected ? '' : 'not-connected border'}`}>
          <div className="img-wrapper center border">
            <img src={cardOg} alt="Original card 17b artwork" className="card border" />
          </div>
          <p className="center pink cell">Original Token</p>
          <p className="card-description cell white border">Original card #17 artwork. Embedded in the blockchain on June 20, 2017. <a rel="noopener noreferrer" target="_blank" href="https://etherscan.io/address/0xE0B5E6F32d657e0e18d4B3E801EBC76a5959e123">View on Etherscan</a></p>
          <div className="couple">
            <p className="couple-left center-vertical white border cell">Unwrapped Balance</p>
            <p className="couple-right center white border cell">{erc20Balance}</p>
          </div>
          <div className="couple">
            <p className="couple-left center-vertical white border cell">How many to wrap?</p>
            <input className="couple-right center pinkLight border" type="number" placeholder="0" min="0" max={newWrapperBalance}
              value={numToWrapFromErc20} onChange={e => setNumToWrapFromErc20(e.target.value)}></input>
          </div>
          <button className="cell center pinkLight border couple on-hover-pink" disabled={inProgress || numToWrapFromErc20 < 1}
            onClick={wrapOriginalTokens}> <img src={wrap} className="icon" alt="" />Wrap to wrap.curio.cards</button>
        </section>

        <section className={`new-wrapper ${connected ? '' : 'border pinkLight'}`}>
          {
            connected ?
              <>
                <div className="img-wrapper center pinkLight border">
                  <img src={cardNew} alt="New card #17b artwork" className=" card border" />
                </div>
                <p className="center pink cell">New Wrapper (wrap.curio.cards)</p>
                <p className="card-description cell white border">New card #17b artwork, created by <a rel="noopener noreferrer" target="_blank" href="https://twitter.com/helloluis">Luis Buenaventura.</a> Can you spot all 17 differences?  <a rel="noopener noreferrer" target="_blank" href="https://opensea.io/collection/curiocardswrapper">View on OpenSea</a></p>
                <div className="couple">
                  <p className="couple-left center-vertical white border cell">Wrapped Balance</p>
                  <p className="couple-right center white border cell">{newWrapperBalance}</p>
                </div>
                <div className="couple">
                  <p className="couple-left center-vertical white border cell">How many to unwrap?</p>
                  <input className="couple-right center pinkLight border" type="number" placeholder="0" min="0" max={newWrapperBalance}
                    value={numToUnwrapFromNewWrapper} onChange={e => setNumToUnwrapFromNewWrapper(e.target.value)}></input>
                </div>
                <button className="cell center pinkLight border couple on-hover-pink" disabled={inProgress || numToUnwrapFromNewWrapper < 1}
                  onClick={unwrapNewWrapperTokens}> <img src={unwrap} className="icon" alt="" />Unwrap to Original Token</button>
              </>
              :
              metamaskPresent ?
                <div className="center empty-state connect-wallet">
                  <p>Please connect your wallet to continue.</p>
                  <button onClick={connectWallet} className="white real-button">Connect</button>
                </div>
                :
                <div className="center empty-state install-metamask">
                  <p>Please install MetaMask to continue.</p>
                  <button onClick={() => window.open('https://metamask.io/')} className="white real-button">Get MetaMask</button>
                </div>
          }
        </section>

        <section className={`old-wrapper ${connected ? '' : 'not-connected border'}`}>
          <div className="img-wrapper center border">
            <img src={cardBootleg} alt="Old card #17b artwork" className="card border" />
          </div>
          <p className="center pink cell">Old Wrapper (wrap.cards)</p>
          <p className="card-description cell white border">Alternate card 17b artwork, created by an anonymous community member. <a rel="noopener noreferrer" target="_blank" href="https://opensea.io/collection/curio-cards-wrapper">View on OpenSea</a></p>
          <div className="couple">
            <p className="couple-left center-vertical white border cell">Wrapped Balance</p>
            <p className="couple-right center white border cell">{oldWrapperBalance}</p>
          </div>
          <div className="couple">
            <p className="couple-left center-vertical white border cell">How many to migrate?</p>
            <input className="couple-right center pinkLight border" type="number" placeholder="0" min="0" max={oldWrapperBalance}
              value={numToUnwrapFromOldWrapper} onChange={e => setNumToUnwrapFromOldWrapper(e.target.value)}></input>
          </div>
          <button className="cell center pinkLight border couple on-hover-pink" disabled={inProgress || numToUnwrapFromOldWrapper < 1}
            onClick={unwrapOldWrapperTokens}> <img src={wrap} className="icon" alt="" />Migrate to wrap.curio.cards</button>
        </section>
      </div>

      <div className="footerdeco">
        <div className="footerart">
          <div className="footerart__wrapper">
            <img src={curio} alt="" />
          </div>
          <div className="footerart__wrapper logo">
            <img src={logo} alt="" />
          </div>
          <div className="footerart__wrapper">
            <img src={cards} alt="" />
          </div>
        </div>
        <div className="footerlink cell border center pinkLight"><p>Card #17B Wrapper</p></div>
      </div>
    </>
  );
}

export default App;
